var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIsHomeLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M31.125 10.24L17.882 1.064a3.285 3.285 0 0 0-3.764 0L.875 10.24a.941.941 0 0 0 1.073 1.544l13.243-9.177a1.412 1.412 0 0 1 1.618 0l13.243 9.177a.941.941 0 1 0 1.073-1.544zM17.882 4.433a3.285 3.285 0 0 0-3.764 0l-1.883 1.28a.944.944 0 1 0 1.073 1.553l1.883-1.29a1.412 1.412 0 0 1 1.618 0l2.72 1.883a.941.941 0 0 0 .537.16.941.941 0 0 0 .536-1.713l-2.72-1.873zM8.98 7.99L6.39 9.779a.941.941 0 0 0-.236 1.317.941.941 0 0 0 1.309.198l2.588-1.76a.941.941 0 0 0 .235-1.308.941.941 0 0 0-1.308-.235zm18.767 3.793a.941.941 0 0 0-.941.94v17.883a.941.941 0 0 0 1.882 0V12.725a.941.941 0 0 0-.941-.941zM17.214 16h-2.428a3.426 3.426 0 0 0-3.379 3.473v11.115a.941.941 0 1 0 1.882 0V19.464a1.544 1.544 0 0 1 1.497-1.582h2.428c.85.031 1.518.74 1.497 1.59v11.116a.941.941 0 1 0 1.882 0V19.464A3.426 3.426 0 0 0 17.214 16zm-12.96-4.273a.941.941 0 0 0-.941.941v17.883a.941.941 0 1 0 1.882 0V12.668a.941.941 0 0 0-.94-.94z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIsHomeLight);
export default __webpack_public_path__ + "static/media/icon-is-home-light.d787b5edf392aa52f02d4f6d90497857.svg";
export { ForwardRef as ReactComponent };